'use client';

import { useFormContext } from 'react-hook-form';

import { CONTACT_COPY } from '@eliadmin/core/src/components/dlz/contact/contact-copy';
import {
  MESSAGE_MAX_LENGTH,
  type ContactFormInput,
} from '@eliadmin/core/src/components/dlz/contact/contact-schema';
import { Textarea } from '@eliadmin/core/src/components/dlz/dialogs/textarea';
import { FormRow } from '@eliadmin/core/src/components/dlz/forms/form-row';
import { formFields } from '@eliadmin/core/src/components/dlz/forms/form-fields';
import { FormField } from '@eliadmin/core/src/components/ui/form';

/** The DLZ form fields bound to the contact form. */
export const { TextField, CheckboxField } = formFields<ContactFormInput>();

/** Figma „Textarea · Správa“: 104 px field (padding 16 / 12) with the character counter as helper. */
export function MessageField({ label, className }: { label: string; className?: string }) {
  const { control } = useFormContext<ContactFormInput>();

  return (
    <FormField
      control={control}
      name="text"
      render={({ field }) => (
        <FormRow
          label={label}
          required
          hint={CONTACT_COPY.counter(field.value.length, MESSAGE_MAX_LENGTH)}
          className={className}
        >
          <Textarea
            {...field}
            placeholder={CONTACT_COPY.placeholders.text}
            maxLength={MESSAGE_MAX_LENGTH}
            className="h-[104px] pb-3 pt-4"
          />
        </FormRow>
      )}
    />
  );
}
